{
  "id": "cnpj-motivos",
  "nome": "RFB CNPJ Motivos de Situação Cadastral",
  "fonte": "Receita Federal — Dados Abertos CNPJ (Motivos.zip)",
  "endpoints": [
    "https://github.com/jonathands/dados-abertos-receita-cnpj/releases/download/2024.09/Motivos.zip"
  ],
  "capturadoEm": "2026-08-11",
  "atualizadoEm": "2026-08-11T05:34:19.666Z",
  "contagens": {
    "motivos": 61
  },
  "alteracoes": {
    "adicionados": 0,
    "removidos": 0,
    "alterados": 0,
    "comparadoCom": "2026-08-05"
  },
  "verificacao": {
    "agendamento": "diario",
    "workflow": "data-refresh-bot.yml",
    "ultimaExecucao": "2026-08-11T05:34:19.666Z"
  },
  "documentacao": "docs/OFFICIAL-SOURCES.md#cnpj-motivos-situacao-cadastral"
}
